import { Form, Header, Message } from "semantic-ui-react"
import BifrostButton from "../../../BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../../../BifrostPageComponent/BifrostModal/BifrostModal"
import Loader from "../../../BifrostPageComponent/Loader/Loader"
import { useConfigureEthernetSettings } from "./useConfigureEthernetSetttings"

const ConfigureEthernetSettingsModal = () => {
	const { state, deviceState, handleDhcpToggle, handleInputChange, toggleModalHandler, handleOKButtonClicked, confirmConfigureEthernetSettings, cancelConfigureEthernetSettings } =
		useConfigureEthernetSettings()

	return (
		<BifrostModal
			title="Configure Ethernet Settings"
			open={state.isDisabled ? false : state.open}
			setOpen={toggleModalHandler}
			closeOnDimmerClick={false}
			closeOnEscape={false}
			trigger={
				<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					<BifrostButton size="medium" disabled={state.isDisabled}>
						Configure Ethernet
					</BifrostButton>
					{deviceState === "offline" && (
						<Message size="mini" content="Device is offline" negative={true} style={{ paddingTop: "7px", paddingBottom: "9px", marginBottom: "0px", marginTop: "0px" }} />
					)}
				</div>
			}
			modalPage={
				<>
					{state.isError && <Message negative content={state.errorMessage} />}
					{state.isFetching && <Loader backgroundColor="white" inverted size="small" />}
					{state.isSuccess && <Message positive content="Configuration saved successfully" />}
					{!state.isFetching && !state.isError && !state.isSuccess && (
						<>
							<Form>
								<>
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center"
										}}
									>
										<Header size="tiny">DHCP</Header>
										<Form.Checkbox toggle checked={state.isDhcpEnabled} onChange={(e, data) => handleDhcpToggle(data.checked)} />
									</div>
								</>
								<Form.Input
									name="ip-addr"
									onChange={(e, data) => handleInputChange("address", data.value)}
									placeholder={`IP Address: ${state.origenEthernetConfigure?.netConfiguration?.address || "0.0.0.0"}`}
									error={state.isInvalidInput.address}
								/>
								<Form.Input
									name="subnet"
									onChange={(e, data) => handleInputChange("netmask", data.value)}
									placeholder={`Subnet Mask: ${state.origenEthernetConfigure?.netConfiguration?.subnetMask || "255.255.255.0"}`}
									error={state.isInvalidInput.netmask}
								/>
								<Form.Input
									name="gateway"
									onChange={(e, data) => handleInputChange("gateway", data.value)}
									placeholder={`Gateway: ${state.origenEthernetConfigure?.netConfiguration?.gateway || "0.0.0.0"}`}
									error={state.isInvalidInput.gateway}
								/>
								<Form.Input
									name="dns"
									onChange={(e, data) => handleInputChange("dns", data.value)}
									placeholder={`DNS: ${state.origenEthernetConfigure?.netConfiguration?.dns || "0.0.0.0"}`}
									error={state.isInvalidInput.dns}
								/>
							</Form>
							<Message
								content={
									"Warning: if you do not enter a Gateway or DNS, and you want to use the Ethernet for WAN, you will lose connection to the Bifrost Unit. It will require physical access to change it back."
								}
							/>
							<Message content={"Please note: After modifying your Ethernet settings, it may take up to 1 minute before a new IP address is assigned."} />
						</>
					)}
				</>
			}
			modalActions={
				<div style={{ display: "flex", justifyContent: "right" }}>
					{state.isError || state.isSuccess ? (
						<BifrostButton onClick={() => handleOKButtonClicked()}>OK</BifrostButton>
					) : (
						<>
							<BifrostButton onClick={() => confirmConfigureEthernetSettings()}>Confirm</BifrostButton>
							<BifrostButton color="gray" onClick={() => cancelConfigureEthernetSettings()}>
								Cancel
							</BifrostButton>
						</>
					)}
				</div>
			}
		/>
	)
}

export default ConfigureEthernetSettingsModal
